export default {"src":"/_next/static/media/setting-goals-calendar.colour.4f6121bd.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};